import { render, staticRenderFns } from "./WenzhenIng.vue?vue&type=template&id=674c60ea&scoped=true"
import script from "./WenzhenIng.vue?vue&type=script&lang=js"
export * from "./WenzhenIng.vue?vue&type=script&lang=js"
import style0 from "./WenzhenIng.vue?vue&type=style&index=0&id=674c60ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674c60ea",
  null
  
)

export default component.exports